import {
    type UseFeatureFlag,
    type UseFeatureVariant,
    type UseRawFeatureFlag,
    usePostHogFeatureFlag,
    usePostHogFeatureVariant,
    useRawPostHogFeatureFlag
} from '@components/PostHogProvider';

export const useFeature: UseFeatureFlag = (flag, defaultValue = false) => {
    return usePostHogFeatureFlag(flag, defaultValue);
};

export const useRawFeature: UseRawFeatureFlag = (flag) => {
    const result = useRawPostHogFeatureFlag(flag);
    return result;
};

export const useFeatureVariant: UseFeatureVariant = (flag) => usePostHogFeatureVariant(flag);

export default useFeature;
